import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import { useEffect, useRef } from "react";
import { ForgotPasswordFooter } from "./components/ForgotPasswordFooter/ForgotPasswordFooter.js";
import { UidField } from "./components/formFields/UidField/UidField.js";
import { UsernameField } from "./components/formFields/UsernameField/UsernameField.js";
import { TextsProvider } from "./contexts/texts.js";
import { forgotPasswordForm, forgotPasswordFormInitialValues } from "./forgotPasswordFormSetup.js";
import { useAutoFocusEmptyField } from "./hooks/useAutoFocusEmptyField.js";
function ForgotPasswordForm(props) {
  const {
    texts,
    onInitialize,
    initialValues,
    onFormApi,
    sx,
    testId = "forgot-password-form-root",
    autoFocus,
    showUid = false,
    onSubmit,
    className = "",
    customSlot,
    componentProps,
    fieldProps,
    ...tidalFormProps
  } = props;
  const rNotifyWrongConfig = useRef(true);
  useEffect(() => {
    if (!rNotifyWrongConfig.current) return;
    if (!onInitialize) return;
    if (!initialValues) return;
    rNotifyWrongConfig.current = false;
    console.warn(
      "[Forgot Password Form] `onInitialize` and `initialValues` are mutually exclusive. `initialValues` will be ignored."
    );
  }, [onInitialize, initialValues]);
  return /* @__PURE__ */ jsx(TextsProvider, { texts, children: /* @__PURE__ */ jsx(
    forgotPasswordForm.Form,
    {
      disableScroll: true,
      fieldsPadding: 0,
      fieldsSpacing: 2,
      sx,
      className,
      ...tidalFormProps,
      testId,
      footer: /* @__PURE__ */ jsx(
        ForgotPasswordFooter,
        {
          showUid,
          autoFocus,
          footerProps: fieldProps?.footerProps,
          buttonProps: {
            ...componentProps?.submitButton,
            ...fieldProps?.submitButton
          }
        }
      ),
      onFormApi,
      onInitialize: () => {
        if (onInitialize) {
          return onInitialize();
        }
        return {
          initialValues: Object.assign({}, forgotPasswordFormInitialValues, initialValues)
        };
      },
      onSubmit: async (formState, formValues, api, formEvent) => {
        await onSubmit(formState);
      },
      children: /* @__PURE__ */ jsx(ForgotPasswordFormFields, { ...props })
    }
  ) });
}
function ForgotPasswordFormFields(props) {
  const { autoFocus, showUid = false, customSlot, componentProps, fieldProps } = props;
  const autoFocusField = useAutoFocusEmptyField(autoFocus, showUid);
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    showUid ? /* @__PURE__ */ jsx(UidField, { autoFocusField, componentProps: componentProps?.uid, fieldProps: fieldProps?.uid }) : null,
    /* @__PURE__ */ jsx(
      UsernameField,
      {
        autoFocusField,
        componentProps: componentProps?.username,
        fieldProps: fieldProps?.username
      }
    ),
    customSlot
  ] });
}
export {
  ForgotPasswordForm
};
//# sourceMappingURL=ForgotPasswordForm.js.map
